import { DomainLv2, DomainLv2FormData } from "../types"
import { ID, PaginationResult } from "@/types/common"
import { createCrudApi } from "@/utils/apiFactory"

const baseApi = createCrudApi<DomainLv2, DomainLv2FormData, DomainLv2FormData>(
  "/domain-lv2s"
)

// 二级领域API
const domainLv2Api = {
  // 查询所有（支持按一级领域筛选）
  async getList(domainLv1Id: ID): Promise<PaginationResult<DomainLv2>> {
    return baseApi.list({ domainLv1Id })
  },

  // ID查询
  async getById(id: ID): Promise<DomainLv2 | null> {
    return baseApi.getById(id)
  },

  // 创建
  async create(data: DomainLv2FormData): Promise<void> {
    await baseApi.create(data)
  },

  // 更新
  async update(id: ID, data: DomainLv2FormData): Promise<void> {
    await baseApi.update(id, data)
  },

  // 删除（统一使用数组参数，支持单个和批量）
  async delete(ids: ID[]): Promise<void> {
    await baseApi.delete(ids)
  },
}

export default domainLv2Api
